export default {
  colors: {
    level1: "#2f529a",
    level2: "#6077ad",
    level3: "#3d65b6",
    level4: "#bfc7cf",

    light: "#fff",
    dark: "#212121",
    success: "#3ab87a",
    danger: "#dc3545",
    warning: "#ffc107",
    line: "#bebebe",
  },

  breakpoints: {
    xl: "1599.98px",
    lg: "1199.98px",
    md: "991.98px",
    sm: "767.98px",
    xs: "575.98px",
  },
};
